/**
 * @file pending-certificates.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/pending-certificates.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/pending-certificates
 * @description Page component for managing pending certificates in the vendors management section.
 *   Displays a list of pending certificates with pagination, search functionality, and CRUD operations.
 *   Allows users to view, edit, and delete pending certificates with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Permission guard commented out: enable hasModulePermission(PendingCertificate) or
 *   equivalent uTrade permission before production.
 * @todo Remove debug console.log calls (certificateData, tempCertificate).
 */

import { useEffect, useState } from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import APICallService from "../../../../api/apiCallService";
import { pendingCertificates } from "../../../../api/apiEndPoints";
import { pendingCertificatesJSON } from "../../../../api/apiJSON/pendingCertificate";
import { IGetPendingCertificate } from "../../../../types/responseIndex";
import Loader from "../../../../Global/loader";
import Pagination from "../../../../Global/pagination";
import { success } from "../../../../Global/toast";
import { pendingCertificatesToast } from "../../../../utils/toast";
import {
  Add,
  AllSeller,
  Edit,
  PAGE_LIMIT,
  PendingCertificate,
} from "../../../../utils/constants";
import { listPendingCertificates } from "../../../../utils/storeString";
import { getKey, setKey } from "../../../../Global/history";
import Method from "../../../../utils/methods";
import { useAuth } from "../../auth";
const PendingCertificates = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [notifLoading, setNotifLoading] = useState(false);
  const [businessId, setBusinessId] = useState("");
  const [fetchLoading, setFetchLoading] = useState(false);
  const [certificateData, setCertificateData] = useState<
    IGetPendingCertificate | any
  >([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState<any>(
    getKey(listPendingCertificates.page) || 1
  );
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listPendingCertificates.limit) || PAGE_LIMIT
  );
  console.log("certificateData", certificateData);
  useEffect(() => {
    (async () => {
      setFetchLoading(true);
      // if (!Method.hasModulePermission(PendingCertificate, currentUser)) {
      //   return window.history.back();
      // }
      await fetchCertificateData(page, pageLimit);
      setFetchLoading(false);
    })();
  }, []);
  const fetchCertificateData = async (pageNo: any, limit: any) => {
    let params: any = {
      pageNo: parseInt(pageNo),
      limit: parseInt(limit),
      sortKey: "name",
      sortOrder: 1,
    };

    let apiService = new APICallService(
      pendingCertificates.listCertificates,
      pendingCertificatesJSON.listCertificates(params),
      "",
      "",
      "",
      "",
      PendingCertificate
    );
    // let response = await apiService.callAPI();
    let response = {
      total: 1,
      records: [
        {
          business: {
            _id: "652d85e19142ddd5489403b5",
            ownerName: "Aunali Sachedina",
            name: "Wadsworth Distributors (T) Limited",
            deactivated: false,
            _createdAt: "2023-10-16T18:50:09.191Z",
            _updatedAt: "2025-12-01T06:33:24.162Z",
            image:
              "http://u-trade-dev.s3.af-south-1.amazonaws.com/business/logo/1697482209133_8094913386785993.jpg",
          },
          pendingCertificates: [
            {
              _id: "692d365d66551ae5ac972ca4",
              title: "C1",
            },
          ],
        },
      ],
    };
    if (response) {
      // if (pageNo === 1) {
      setTotalRecords(response.total);
      // } else {
      //   let prevTotal = totalRecords;
      //   setTotalRecords(prevTotal);
      // }
      setCertificateData(response.records);
    }
  };
  const handleCurrentPage = async (val: number) => {
    setLoading(true);
    setPage(val);
    setKey(listPendingCertificates.page, val);
    await fetchCertificateData(val, pageLimit);
    setLoading(false);
  };
  const handleNextPage = async (val: number) => {
    setLoading(true);
    setPage(val + 1);
    setKey(listPendingCertificates.page, val + 1);
    await fetchCertificateData(val + 1, pageLimit);
    setLoading(false);
  };
  const handlePreviousPage = async (val: number) => {
    setLoading(true);
    setPage(val - 1);
    setKey(listPendingCertificates.page, val - 1);
    await fetchCertificateData(val - 1, pageLimit);
    setLoading(false);
  };
  const handlePageLimit = async (event: any) => {
    setLoading(true);
    setPage(1);
    await setPageLimit(parseInt(event.target.value));
    setKey(listPendingCertificates.page, 1);
    setKey(listPendingCertificates.limit, parseInt(event.target.value));
    await fetchCertificateData(1, event.target.value);
    setLoading(false);
  };
  const handleNotification = async (id: string) => {
    let tempCertificate = certificateData?.find((certVal: any) => {
      return certVal?.business?._id === id;
    });
    console.log("tempCertificate", tempCertificate);
    return;
    setNotifLoading(true);
    setBusinessId(id);
    let apiService = new APICallService(
      pendingCertificates.notifyCertificates,
      {},
      { id: id },
      "",
      "",
      "",
      PendingCertificate
    );
    let response = await apiService.callAPI();
    if (response) {
      success(pendingCertificatesToast.notified);
    }
    setNotifLoading(false);
  };
  return (
    <>
      <div className="p-5">
        <Row>
          <Col xs={12} className="mb-6">
            <h1 className="fs-22 fw-bolder">Pending certificates</h1>
          </Col>
          {fetchLoading ? (
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoading} />
            </div>
          ) : (
            <>
              {!certificateData?.length ? (
                <Col xs>
                  <Card className="border border-r10px p-7 pb-3">
                    <Card.Body>
                      <div className="d-flex flex-column flex-center">
                        <h3 className="fs-22 fw-bold">
                          No pending certificates
                        </h3>
                        <p className="fs-18 fw-500 text-center mw-lg-450px">
                          Vendors who have not uploaded the required
                          certificates will be shown here.
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ) : (
                <></>
              )}
            </>
          )}{" "}
        </Row>
        {fetchLoading ? (
          <></>
        ) : (
          <>
            {certificateData?.length ? (
              <Row>
                <Col xs>
                  <Card className="border border-r10px">
                    <Card.Body className="p-0">
                      <div className="table-responsive">
                        <table className="table table-rounded table-row-bordered align-middle gs-7 gy-4 mb-0">
                          <thead>
                            <tr className="fs-16 fw-bold text-dark border-bottom h-70px align-middle">
                              <th className="min-w-275px">Business name</th>
                              <th className="min-w-375px">
                                Pending certificate
                              </th>
                              <th className="min-w-175px text-end"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={3}>
                                  <div className="w-100 d-flex justify-content-center">
                                    <Loader loading={loading} />
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <>
                                {certificateData?.map(
                                  (certVal: any, certIndex: number) => {
                                    return (
                                      <tr key={certIndex}>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="symbol symbol-50px border me-5">
                                              <img
                                                src={certVal?.business?.image}
                                                className="object-fit-contain"
                                                alt=""
                                              />
                                            </div>
                                            <div className="fs-15 fw-600">
                                              {certVal?.business?.name}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <Row className="g-2">
                                            {certVal?.pendingCertificates?.map(
                                              (
                                                pendingVal: any,
                                                pendingIndex: number
                                              ) => {
                                                return (
                                                  <Col xs="auto">
                                                    <span className="badge badge-light border-r23px p-4 fs-15 fw-600 text-dark">
                                                      {pendingVal.title}
                                                    </span>
                                                  </Col>
                                                );
                                              }
                                            )}
                                          </Row>
                                        </td>
                                        <td className="text-end">
                                          {Method.hasPermission(
                                            PendingCertificate,
                                            Add,
                                            currentUser
                                          ) ? (
                                            <Button
                                              variant="primary"
                                              className="uw-btn uw-btn-primary fs-14 fw-600"
                                              onClick={() => {
                                                handleNotification(
                                                  certVal.business._id
                                                );
                                              }}
                                            >
                                              {notifLoading ? (
                                                <>
                                                  {certVal?.business?._id ===
                                                  businessId ? (
                                                    <span
                                                      className="indicator-progress"
                                                      style={{
                                                        display: "block",
                                                      }}
                                                    >
                                                      Please wait...
                                                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                    </span>
                                                  ) : (
                                                    <span className="indicator-label">
                                                      Notify seller
                                                    </span>
                                                  )}
                                                </>
                                              ) : (
                                                <span className="indicator-label">
                                                  Notify seller
                                                </span>
                                              )}
                                            </Button>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </>
        )}
        {!fetchLoading ? (
          <>
            {certificateData?.length ? (
              <Pagination
                totalRecords={totalRecords}
                currentPage={page}
                handleCurrentPage={(event: any) => {
                  handleCurrentPage(event);
                }}
                handleNextPage={(event: any) => {
                  handleNextPage(event);
                }}
                handlePreviousPage={(event: any) => {
                  handlePreviousPage(event);
                }}
                pageLimit={pageLimit}
                handlePageLimit={(event: any) => {
                  handlePageLimit(event);
                }}
              />
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
export default PendingCertificates;
